module.exports = __webpack_public_path__ + "static/media/product-1-side.6bff3c0b.jpg";